export enum LocalStorageKeys {
  AcceptedTerms = 'AcceptedTerms',
  AcceptedPrivacyPolicy = 'AcceptedPrivacyPolicy',
  SavedRegisterForm = 'SavedRegisterForm',
  SavedMortgageForm = 'SavedMortgageForm',
  // Demo
  DemoCurrentStepName = 'DemoCurrentStepName',
}
